import { render, staticRenderFns } from "./OfficialHolidaysPlanAdd.vue?vue&type=template&id=13c9d934&scoped=true&"
import script from "./OfficialHolidaysPlanAdd.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9d934",
  null
  
)

export default component.exports